var exports = {
  "k": "x127c5a35--07cb58--container",
};

module.exports = exports;
